import { render, staticRenderFns } from "./FooterMenu.vue?vue&type=template&id=468d34fc"
var script = {}
import style0 from "./FooterMenu.vue?vue&type=style&index=0&id=468d34fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports